import RequesterV1 from "@/components/api/v1/requester.js";

export default {
  fetchAgroExporterProcess(agro_exporter_id, agro_exporter_process_id) {
    return RequesterV1.get(
      `agro_exporter/production/basic_container_quality/show_process/${agro_exporter_id}/fetch_agro_exporter_process/${agro_exporter_process_id}`
    );
  },

  fetchContainers(agro_exporter_id, agro_exporter_process_id) {
    return RequesterV1.get(
      `agro_exporter/production/basic_container_quality/show_process/${agro_exporter_id}/fetch_containers/${agro_exporter_process_id}`
    );
  },

  downloadReport(agro_exporter_id, agro_exporter_process_id) {
    return RequesterV1.get(
      `agro_exporter/production/basic_container_quality/show_process/${agro_exporter_id}/download_report/${agro_exporter_process_id}`,
      { responseType: "blob"  }
    );
  }
};
